// extracted by mini-css-extract-plugin
export default {"adItems2Container":"AdItems2_adItems2Container__hSeW9","adItems2VideoDuration":"AdItems2_adItems2VideoDuration__9lEF3"};